var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_7739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1363 5.91783C14.1363 8.6532 11.9183 10.8719 9.18221 10.8719C6.44613 10.8719 4.2281 8.6532 4.2281 5.91783C4.2281 3.18104 6.44613 0.963013 9.18221 0.963013C11.9183 0.963013 14.1363 3.18104 14.1363 5.91783ZM13.0054 10.9993C11.9395 11.804 10.6175 12.2874 9.18221 12.2874C7.74552 12.2874 6.42277 11.8026 5.35551 10.9979C2.47364 12.2669 0.689453 16.2181 0.689453 17.9485H17.675C17.675 16.2337 15.8349 12.2824 13.0054 10.9993Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_7739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9855,
    height: 16.9855,
    fill: "white",
    transform: "translate(0.689453 0.962891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormNameIcon);
export default __webpack_public_path__ + "static/media/formNameIcon.33b2a1478368cc5807c995ebb113d98d.svg";
export { ForwardRef as ReactComponent };